import React from "react";
import "./services.scss";
import Button from "../../Common/Button/Button";
import services from "../../../assets/UMSImage/Specialties_header.png"

const Services = () => {
  return (
    <section id="services-wrapper">
        <div className="services">
        <div className="row">
        <div className="col-md-6 services-image des-hide">
            <img src={services} alt="" />
        </div>
        <div className="col-md-6 services-content">
          <h1 className="heading">
            Specialties <span>Services</span>
          </h1>
          <p>
            At UMS, we understand the challenges that healthcare providers face
            when it comes to managing their billing processes. That's why we
            offer a range of customizable services that are tailored to meet the
            unique needs of each of our clients. From coding and claim
            submission to denial management and appeals, we are committed to
            providing exceptional customer service and delivering measurable
            results.
          </p>
          <Button id="arrow-wrapper-right">Appointment</Button>
        </div>
        <div className="col-md-6 services-image tab-hide">
            <img src={services} alt="" />
        </div>
      </div>
        </div>
  
    </section>
  );
};

export default Services;
